module.exports = __webpack_public_path__ + "img/franchising_accomplishments_3.ebae6540.svg";